import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ number, eyebrow, title, dark = false }) => (
    <div className="mb-14 md:mb-20">
        <Reveal>
            <div className="flex items-baseline gap-5">
                <span
                    className={`font-serif text-6xl md:text-8xl font-light leading-none ${
                        dark ? "text-outline" : "text-outline"
                    }`}
                >
                    {number}
                </span>
                <span
                    className={`text-xs uppercase tracking-[0.35em] ${
                        dark ? "text-gold" : "text-burgundy"
                    }`}
                >
                    {eyebrow}
                </span>
            </div>
        </Reveal>
        <Reveal delay={0.12}>
            <h2
                className={`mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] ${
                    dark ? "text-ivory" : "text-ink"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        <Reveal delay={0.2}>
            <div className="mt-8 h-px w-24 bg-gold/70" />
        </Reveal>
    </div>
);
